export default "__VITE_ASSET__2a2b02c4__"